/**
 * A bundled json with remote: "remoteconfig://<path>" gets its live copy downloaded once on startup from
 * <remoteConfigURL>/<path>; on any error, or without remote, the bundled json stays.
 *
 * Created by andrey on 15.09.2026
 */

const RemoteConfig = function (json) {
    this.json = json;

    if (RemoteConfig.isApplicable(json) && connector.config.remoteConfigURL && !cleverapps.flags.norest) {
        this.remote = json.remote;
    }
};

RemoteConfig.isApplicable = function (json) {
    return json && typeof json.remote === "string" && json.remote.startsWith("remoteconfig://");
};

RemoteConfig.prototype.getJson = function () {
    return this.json;
};

RemoteConfig.prototype.initialize = function (callback) {
    callback();
};

RemoteConfig.prototype.fetch = function (callback) {
    if (!this.remote || this.fetched) {
        callback();
        return;
    }

    this.fetchCallbacks = this.fetchCallbacks || [];
    this.fetchCallbacks.push(callback);

    if (this.fetching) {
        return;
    }

    this.fetching = true;

    const start = Date.now();

    connector._loadConfig(this.remote, (json) => {
        this.fetching = false;
        this.fetched = true;

        if (json) {
            cleverapps.config.debugMode && console.log(`RemoteConfig ${this.remote} fetch success - ${Date.now() - start}ms`);
            this.json = json;
        } else {
            console.log(`RemoteConfig ${this.remote} fetch failed, keeping bundled json`);
        }

        const callbacks = this.fetchCallbacks;
        delete this.fetchCallbacks;
        callbacks.forEach((callback) => callback());
    }, { attempts: 3 });
};
